export const MODAL_RESET = "MODAL_RESET";
export const MODAL_SHOW = "MODAL_SHOW";
export const SET_LOADING = "SET_LOADING";
export const SET_LOADING_TABLE = "SET_LOADING_TABLE";

export const SET_ERROR = "SET_ERROR";
export const ALERT_RESET = "ALERT_RESET";
export const ALERT_SHOW = "ALERT_SHOW";
export const SET_LOADING_BERANDA = "SET_LOADING_BERANDA";
export const SET_LOADING_FILTER = "SET_LOADING_FILTER";
export const SET_LOADING_COMMENT = "SET_LOADING_COMMENT";